(function($) {

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-active')) {
            primaryNavigation.removeClass('is-active');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');

        } else {
            primaryNavigation.addClass('is-active');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
        }
    });

    // Close mobile menu when clicking on scrollspy element
    if ($(window).width() <= 991) {
        $('#navScollspy .nav-link').on('click', function() {
            $('#primaryNavigation').removeClass('is-active');
            $('#navbarToggle').addClass('collapsed');
            $('body').removeClass('no-scroll');
        });
    }

}(jQuery));



// WEBPACK FOOTER //
// ./js/src/app/primary-navigation.js